import Cookies from "js-cookie";

import { useMutation } from "@tanstack/react-query";

import { SignOutFormApi } from "../api";

export const useSendSignOut = () => {
  return useMutation(SignOutFormApi.signOut, {
    onSuccess: async () => {
      Cookies.remove("rlogin");
      window.location.reload();
    },
  });
};
